import { Injectable } from '@angular/core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DetailedEntityDataEditorService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { SharedServiceRegistry } from '../../../shared-service-registry';


@Injectable()
export class PickManagementPopupDataEditorService extends DetailedEntityDataEditorService {

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }
  /**
  * This method handles the changes to the property value
  * @param event - Property Change Event
  */
  public propertyValueChanged(): boolean {
    return true;
  }
  /**
   * This method is used to refresh the cells of the table
   * @param params - cell params
   */
  public refreshCells(params: any) {
    params.api.refreshCells({ rowNodes: [params.node] });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-control-popups/pick-management-popup/pick-management-popup-data-editor.service.ts